import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class UpdateExams extends Component {
  state = {
    examId: "",
    exam_name: "",
    exam_date: "",
    exam_type: "",
    exam_venue: "",
    exam_poster: null, // new file
    existing_poster: "", // from DB
    description: "",
    status: "inactive",

    // exam result
    result_url: "",
    result_declared_on: "",

    // multiple exam documents
    exam_documents: [
      {
        doc_name: "",
        doc_url: "",
        is_mandatory: false,
      },
    ],

    message: "",
    notification: false,
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getSingleExam();
  }

  getSingleExam = () => {
    if (init() === "success") {
      const examId = window.location.pathname.split("/")[2];

      axios
        .get(Constants.getUrls.getAllExams + "/" + examId)
        .then((resp) => {
          if (resp.data?.status === "success") {
            const exam = resp.data.data || {};
            const exam_result = exam.exam_result || {};
            const docs = Array.isArray(exam.exam_documents) ? exam.exam_documents : [];

            this.setState({
              examId: exam._id,
              exam_name: exam.exam_name || "",
              exam_date: exam.exam_date ? String(exam.exam_date).slice(0, 10) : "",
              exam_type: exam.exam_type || "",
              exam_venue: exam.exam_venue || "",
              existing_poster: exam.exam_poster || "",
              description: exam.description || "",
              status: exam.status || "inactive",
              result_url: exam_result.result_url || "",
              result_declared_on: exam_result.declared_on
                ? String(exam_result.declared_on).slice(0, 10)
                : "",
              exam_documents:
                docs.length > 0
                  ? docs.map((d) => ({
                      doc_name: d.doc_name || "",
                      doc_url: d.doc_url || "",
                      is_mandatory: d.is_mandatory || false,
                    }))
                  : [
                      {
                        doc_name: "",
                        doc_url: "",
                        is_mandatory: false,
                      },
                    ],
            });
          } else {
            this.setState({
              notification: true,
              notiColor: "warning",
              message: resp.data?.message || "Failed to fetch exam",
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: err?.response?.data?.message || "Error fetching exam",
          });
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleDocumentChange = (index, field, value) => {
    const docs = [...this.state.exam_documents];
    docs[index][field] = value;
    this.setState({ exam_documents: docs });
  };

  addDocumentRow = () => {
    this.setState((prevState) => ({
      exam_documents: [
        ...prevState.exam_documents,
        { doc_name: "", doc_url: "", is_mandatory: false },
      ],
    }));
  };

  removeDocumentRow = (index) => {
    const docs = [...this.state.exam_documents];
    if (docs.length === 1) return; // keep at least one row
    docs.splice(index, 1);
    this.setState({ exam_documents: docs });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {
      examId,
      exam_name,
      exam_date,
      exam_type,
      exam_venue,
      exam_poster,
      description,
      status,
      result_url,
      result_declared_on,
      exam_documents,
    } = this.state;

    if (!exam_name || !exam_date || !exam_type) {
      this.setState({
        notification: true,
        notiColor: "warning",
        message: "Exam name, date and type are required!",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    const fd = new FormData();
    fd.append("exam_name", exam_name);
    fd.append("exam_date", exam_date);
    fd.append("exam_type", exam_type);
    fd.append("exam_venue", exam_venue);
    fd.append("description", description);
    fd.append("status", status);

    if (exam_poster) {
      fd.append("exam_poster", exam_poster);
    }

    const cleanedDocs = exam_documents.filter((d) => d.doc_name || d.doc_url);
    fd.append("exam_documents", JSON.stringify(cleanedDocs));

    const exam_result = {
      result_url: result_url || "",
      declared_on: result_declared_on || null,
    };
    fd.append("exam_result", JSON.stringify(exam_result));

    if (init() === "success") {
      this.setState({ loading: true });

      axios
        .put(Constants.putUrls.updateExam + examId, fd)
        .then((resp) => {
          this.setState({
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Exam updated successfully!",
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: err?.response?.data?.message || "Failed to update exam",
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/exams" />;
    } else {
      const { exam_documents, existing_poster } = this.state;

      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Update Competitive Exam
                  </MDTypography>
                </MDBox>

                <MDBox py={3} px={2}>
                  <form onSubmit={this.handleSubmit}>
                    <Grid container sm={12} spacing={2}>
                      {/* Exam Name */}
                      <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="Exam Name"
                          name="exam_name"
                          onChange={this.handleInput}
                          value={this.state.exam_name}
                          required
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Date */}
                      <Grid item sm={6}>
                        <TextField
                          type="date"
                          label="Exam Date"
                          name="exam_date"
                          onChange={this.handleInput}
                          value={this.state.exam_date}
                          InputLabelProps={{ shrink: true }}
                          required
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Type */}
                      <Grid item sm={6}>
                        <InputLabel>Select Exam Type</InputLabel>
                        <Select
                          value={this.state.exam_type}
                          onChange={(e) => this.setState({ exam_type: e.target.value })}
                          name="exam_type"
                          label="Select Exam Type"
                          required
                          style={{ width: "100%", height: "45px", color: "#111" }}
                        >
                          <MenuItem value="">Select Exam Type</MenuItem>
                          <MenuItem value="online" style={{ color: "#111" }}>
                            Online
                          </MenuItem>
                          <MenuItem value="offline" style={{ color: "#111" }}>
                            Offline
                          </MenuItem>
                          <MenuItem value="mixed" style={{ color: "#111" }}>
                            Mixed
                          </MenuItem>
                        </Select>
                      </Grid>

                      {/* Exam Venue */}
                      <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="Exam Venue"
                          name="exam_venue"
                          onChange={this.handleInput}
                          value={this.state.exam_venue}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Poster (new upload) */}
                      <Grid item sm={6}>
                        <TextField
                          type="file"
                          label="Exam Poster"
                          name="exam_poster"
                          focused
                          onChange={(e) => {
                            this.setState({
                              exam_poster: e.target.files[0],
                            });
                          }}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Existing Poster Preview */}
                      <Grid item sm={6}>
                        {existing_poster ? (
                          <div>
                            <MDTypography variant="button">Current Poster:</MDTypography>
                            <br />
                            <img
                              src={Constants.imageDomain + existing_poster}
                              alt="Exam Poster"
                              style={{
                                height: "80px",
                                width: "180px",
                                objectFit: "cover",
                                marginTop: 4,
                              }}
                            />
                          </div>
                        ) : (
                          <MDTypography variant="button">No poster uploaded</MDTypography>
                        )}
                      </Grid>

                      {/* Status */}
                      <Grid item sm={6}>
                        <InputLabel>Select Status</InputLabel>
                        <Select
                          value={this.state.status}
                          onChange={(e) => this.setState({ status: e.target.value })}
                          name="status"
                          label="Select Status"
                          style={{ width: "100%", height: "45px", color: "#111" }}
                        >
                          <MenuItem value="inactive" style={{ color: "#111" }}>
                            Inactive
                          </MenuItem>
                          <MenuItem value="active" style={{ color: "#111" }}>
                            Active
                          </MenuItem>
                        </Select>
                      </Grid>

                      {/* Result URL */}
                      <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="Result URL (Optional)"
                          name="result_url"
                          onChange={this.handleInput}
                          value={this.state.result_url}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Result Declared On */}
                      <Grid item sm={6}>
                        <TextField
                          type="date"
                          label="Result Declared On (Optional)"
                          name="result_declared_on"
                          onChange={this.handleInput}
                          value={this.state.result_declared_on}
                          InputLabelProps={{ shrink: true }}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Documents */}
                      <Grid item sm={12}>
                        <MDTypography variant="button" fontWeight="bold">
                          Exam Documents
                        </MDTypography>
                      </Grid>

                      {exam_documents.map((doc, index) => (
                        <React.Fragment key={index}>
                          <Grid item sm={5}>
                            <TextField
                              type="text"
                              label={`Document Name #${index + 1}`}
                              value={doc.doc_name}
                              onChange={(e) =>
                                this.handleDocumentChange(index, "doc_name", e.target.value)
                              }
                              style={{ width: "100%", height: "100%" }}
                            />
                          </Grid>
                          <Grid item sm={5}>
                            <TextField
                              type="text"
                              label={`Document URL #${index + 1}`}
                              value={doc.doc_url}
                              onChange={(e) =>
                                this.handleDocumentChange(index, "doc_url", e.target.value)
                              }
                              style={{ width: "100%", height: "100%" }}
                            />
                          </Grid>
                          <Grid item sm={2} style={{ display: "flex", alignItems: "center" }}>
                            {exam_documents.length > 1 && (
                              <MDButton
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => this.removeDocumentRow(index)}
                              >
                                Remove
                              </MDButton>
                            )}
                          </Grid>
                        </React.Fragment>
                      ))}

                      <Grid item sm={12}>
                        <MDButton
                          variant="outlined"
                          color="info"
                          size="small"
                          onClick={this.addDocumentRow}
                        >
                          Add Document
                        </MDButton>
                      </Grid>

                      {/* Description */}
                      <Grid item sm={12}>
                        <MDTypography variant="button" fontWeight="bold">
                          Description
                        </MDTypography>
                        <SunEditor
                          setDefaultStyle="font-family: Arial; font-size: 16px;"
                          setOptions={{
                            buttonList: [
                              ["undo", "redo"],
                              ["font", "fontSize"],
                              ["paragraphStyle", "blockquote"],
                              ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                              ["fontColor", "hiliteColor"],
                              ["align", "list", "lineHeight"],
                              ["outdent", "indent"],
                              ["table", "horizontalRule", "link", "image", "video"],
                              ["imageGallery"],
                              ["preview", "print"],
                              ["removeFormat"],
                            ],
                            defaultTag: "div",
                            height: 120,
                            showPathLabel: false,
                          }}
                          name="description"
                          setContents={this.state.description}
                          onChange={this.handleDescription}
                        />
                      </Grid>
                    </Grid>

                    <Grid align="left" mt={2}>
                      <MDButton variant="contained" size="small" color="info" type="submit">
                        {this.state.loading ? "Updating..." : "Update"}
                      </MDButton>
                    </Grid>
                  </form>
                </MDBox>

                <MDSnackbar
                  color={this.state.notiColor}
                  icon="notifications"
                  title="Competitive Exams Admin"
                  content={this.state.message}
                  dateTime="Just now"
                  open={this.state.notification}
                />
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
